<template>
    <Widget title="Comment Data" :area="this.$props.area">
        <template v-if=hasData>
            <NameValue type="karma" name="Best" :value="best.score" :link="`https://reddit.com${best.permalink}`"/>
            <NameValue type="karma" name="Worst" :value="worst.score" :link="`https://reddit.com${worst.permalink}`"/>
            <NameValue type="karma" name="Last" :value="last.score" :link="`https://reddit.com${last.permalink}`"/>
            <NameValue type="karma" name="Oldest" :value="old.score" :link="`https://reddit.com${last.permalink}`"/>
            <NameValue name="Count" :value="sorted.length"/>
            <NameValue type="karma" name="Karma" :value="karma"/>
            <NameValue type="karma" name="Avg. Karma" :value="avg_karma"/>
            <NameValue name="Gilded" :value="gilded.length" :callback="open"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";

    export default {
        components: {NameValue, Widget},
        props: {area: String, dialog: Function},
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            hasData() {
                return this.comments.length > 0;
            },
            sorted() {
                return this.comments.slice(0).sort((a, b) => b.data.score - a.data.score);
            },
            last() {
                return this.comments[0].data;
            },
            old() {
                return this.comments[this.comments.length - 1].data;
            },
            best() {
                return this.sorted[0].data
            },
            worst() {
                return this.sorted[this.sorted.length - 1].data
            },
            karma() {
                return this.comments.reduce((t, c) => t + c.data.score, 0);
            },
            avg_karma() {
                return parseInt((this.karma * 10 / this.comments.length), 10) / 10;
            },
            gilded() {
                return this.comments.filter(d => d.data.gilded > 0);
            }
        },
        methods: {
            open() {
                this.dialog('Gilded Links', this.gilded)
            }
        }
    }
</script>

<style scoped>

</style>
